import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Nav from './Nav';
import Home from './Home';
import Fleet from './Fleet';
import VehicleDetail from './VehicleDetail';
import About from './About';
import Terms from './Terms';
import OwnerReservations from './OwnerReservations';

function NotFound() {
  return (
    <section className="not-found">
      <h1>Page not found</h1>
      <p>
        <Link to="/">Back to Home</Link>
      </p>
    </section>
  );
}

function App() {
  return (
    <div className="App">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <header className="App-header">
        <Nav />
      </header>
      <main id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fleet" element={<Fleet />} />
          <Route path="/fleet/:slug" element={<VehicleDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/owner" element={<OwnerReservations />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <footer>
        <p>&copy; {new Date().getFullYear()} Modern Cars LLC</p>
        <p>
          <Link to="/terms">Terms and Conditions</Link>
        </p>
      </footer>
    </div>
  );
}

export default App;
